import React from 'react'
import { flattenSpansEvents, TimelineSpan } from '../domain/TimelineSpan'
import { TraceSpanCategory } from '../domain/Trace'
import Router from '../router'
import { groupSpans } from './groupSpans'
import SpanService from './spanService'
import Span from './timeline/span'
import Summary, { SummaryLine } from './summary'
import { LayerReport } from '../domain/TraceSummary'
import { TraceDetailsLayerReport } from './tracedetails/TraceDetailsLayerReport'

interface Props {
    categories: { [category: string]: TraceSpanCategory }
    spans: TimelineSpan[]
    params?: { [name: string]: string }
    router: Router
    route: string
    publicVersion: boolean
    layerReport: LayerReport
}

class SpanBasedSummary extends React.Component<Props> {
    public static defaultProps = {
        route: 'XhprofProfilerBundle.Profile.summary',
        publicVersion: false,
    }
    private spans: TimelineSpan[]
    private spanService: SpanService

    constructor(props) {
        super(props)
        this.spans = []
        this.spanService = new SpanService()
    }

    public selectSpan(spanId) {
        this.setQueryParameter({ span: spanId })
    }

    public setQueryParameter(values) {
        const params = { ...this.props.params, ...values }
        this.props.router.replace(this.props.route, params)
    }

    public render() {
        const { router, layerReport, categories } = this.props

        const maxWt = Math.max(...this.props.spans.map(span => span.wt))
        const mergedEvents = flattenSpansEvents(this.props.spans)
        const groupedSpans = groupSpans(mergedEvents, maxWt)

        const lines: SummaryLine[] = groupedSpans.map(span => ({
            name: span.name,
            callCount: Number(span.ct),
            wallTime: span.wt,
            wallTimePercentage: span.perc_wt ?? 0,
            exclusiveWallTime: span.excl_wt,
            exclusiveWallTimePercentage: span.perc_excl_wt ?? 0,
            category: this.getSpanCategory(span),
            id: span.id,
            hasDetails: span.type === 'span',
            fn: span.fn,
        }))

        this.spans = this.spanService.sort(this.props.spans)
        const selectedSpanId =
            this.props.params && this.props.params.span ? this.props.params.span : this.spans && this.spans[0] ? this.spans[0].id : null
        const selectedSpan = this.spans.find(span => span.id === selectedSpanId) || null

        return (
            <Summary
                lines={lines}
                selectedLineId={selectedSpanId}
                categories={categories}
                router={router}
                onLineClick={line => this.selectSpan(line.id)}
                details={
                    this.spans && selectedSpan ? (
                        <>
                            <div className="timeline-info">
                                <Span
                                    wt={this.spans[0].wt}
                                    mc={this.spans[0].mc}
                                    span={selectedSpan}
                                    parents={this.spanService.getParents(this.spans, selectedSpan)}
                                    categories={this.props.categories}
                                    route={this.props.route}
                                    showSettingsLink={!this.props.publicVersion}
                                    sectionBelowTitle={
                                        selectedSpanId === this.spans[0]?.id ? (
                                            <TraceDetailsLayerReport layerReport={layerReport} wt={this.spans[0].wt} />
                                        ) : null
                                    }
                                    bottleneckRoute={
                                        this.props.publicVersion
                                            ? 'XhprofCoreBundle.Public.sharedTrace.bottlenecks'
                                            : 'XhprofProfilerBundle.Profile.bottlenecksReport'
                                    }
                                />
                            </div>
                        </>
                    ) : null
                }
                isAggregated={false}
            />
        )
    }

    private getSpanCategory(span: TimelineSpan): TraceSpanCategory {
        if (span.cat in this.props.categories) {
            return this.props.categories[span.cat]
        }

        let label = span.cat
        if (span.cat === 'custom' && span.custom_type) {
            label = span.custom_type
        }

        return { className: 'php', label: `Custom [${label}]` }
    }
}

export default SpanBasedSummary
